import _ from "lodash";
import { Types } from "../actions/permissionActions";


const permissionReducers = (state, action) => {
  console.log("OK12", action.type)
  switch (action.type) {

    case Types.PERMISSION_INVITED_MANAGER: {
     
      let newState = _.cloneDeep(state);

      newState.permissions = {
        ...newState.permissions,
        sendingInvite: false,
        inviteSent: true
      };
    
      return newState;
    }
    case Types.PERMISSION_AOP_MODAL: {

      let newState = _.cloneDeep(state);

      newState.permissions = {
        ...newState.permissions,
        actionOnPermModal: action.open ? action.open : undefined
      }

      return newState;
    }
    case Types.PERMISSION_INVITING_MANAGER: {
     
      let newState = _.cloneDeep(state);

      newState.permissions = {
        ...newState.permissions,
        sendingInvite: action.status ? true : undefined,
      };
    
      return newState;
    }

    case Types.PERMISSION_INVITE_MANAGER_MODAL: {
     
      let newState = _.cloneDeep(state);

      newState.permissions = {
        ...newState.permissions,
        inviteManagerModal: action.status,
        sendingInvite: false,
        inviteSent: false,
      };
    
      return newState;
    }

    case Types.PERMISSION_MY: {

      let newState = _.cloneDeep(state);

      newState.permissions = {
        ...newState.permissions,
        my: action.payload
      }

      return newState;
    }
    case Types.PERMISSION_INVITE_USER_MODAL: {

      let newState = _.cloneDeep(state);

      newState.permissions = {
        ...newState.permissions,
        inviteUser: action.status ? action.status : undefined
      }

      return newState;
    }
    case Types.PERMISSION_INVITED_USER: {

      let newState = _.cloneDeep(state);

      newState.permissions = {
        ...newState.permissions,
        inviteUser: false
      }

      return newState;
    }
    case Types.PERMISSION_GET: {

      let newState = _.cloneDeep(state);

      newState.permissions = {
        ...newState.permissions,
        ...action.payload
      }

      // NotificationManager.success(`Your Grade has been saved`,'Success')

      return newState;
    }
    case Types.PERMISSION_SAVING: {

      let newState = _.cloneDeep(state);

      const authorisedUsers = newState.permissions.authorisedUsers
      const {user} = action

      const userIndex = authorisedUsers.findIndex(u => u.id == user)

      const userPermissions = {...authorisedUsers[userIndex]}

      userPermissions.saving = true

      authorisedUsers[userIndex] = userPermissions

      newState.permissions = {
        ...newState.permissions,
        authorisedUsers, 
      }

      // NotificationManager.success(`Your Grade has been saved`,'Success')

      return newState;
    }
    case Types.PERMISSION_SAVE: {

      let newState = _.cloneDeep(state);


      const authorisedUsers = newState.permissions.authorisedUsers
      const {user} = action

      const userIndex = authorisedUsers.findIndex(u => u.id == user)

      const userPermissions = {...authorisedUsers[userIndex]}

      userPermissions.saving = false
      userPermissions.saved = true
      userPermissions.dirty = false

      authorisedUsers[userIndex] = userPermissions

      newState.permissions = {
        ...newState.permissions,
        authorisedUsers, 
      }

      // NotificationManager.success(`Your Grade has been saved`,'Success')

      return newState;
    }
    case Types.PERMISSION_UPDATE: {

      let newState = _.cloneDeep(state);

      const {user,permission,value} = action

      const authorisedUsers = newState.permissions.authorisedUsers

      const userIndex = authorisedUsers.findIndex(u => u.id == user)

      const userPermissions = {...authorisedUsers[userIndex]}

      if (!userPermissions.permissions){
        userPermissions.permissions = {
          [permission]: value
        }
      } else {
        userPermissions.permissions[permission] = value
      }
      userPermissions.dirty = true

      authorisedUsers[userIndex] = userPermissions

      newState.permissions = {
        ...newState.permissions,
        authorisedUsers, 
      }

      // NotificationManager.success(`Your Grade has been saved`,'Success')

      return newState;
    }
    default:
      return state;
  }
};

export default permissionReducers;